import Order from './views/Order'
import DetailOrder from './views/DetailOrder'

const route = [
  {
    path: '/details-commande/:order_id',
    name: 'detailorder',
    component: DetailOrder,
    props: {
      default: true
    },
    meta: {
      layout: 'default',
      auth: true,
      title: 'Détails de la commande',
      lang_code: 'order_details',
      role: ['A','R','C','I']
    }
  },
  {
    path: '/commandes',
    name: 'order',
    component: Order,
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      title: 'Mes commandes',
      lang_code: 'my_orders',
      role: ['A','R','C','I'],
      customer_required: true,
      order: 3
    }
  },
]

export default route